import { Route, Routes, useLocation } from 'react-router-dom';
import Header from './pages/Shared/Header/Header';
import Home from './pages/Home/Home';
import Footer from './pages/Shared/Footer/Footer';
import Clients from './pages/Clients/ClientTable/Clients';
import Excursions from './pages/Excursions/Excursions';
import ClientDetails from './pages/Clients/ClientDetails/ClientDetails';
import ExcursionDetailsPage from './pages/Excursions/ExcursionDetailsPage';
import Login from './pages/Auth/Login';
import ForbiddenPage from './pages/ForbiddenPage/ForbiddenPage';
import React from 'react';
import ProtectedRoute from './ProtectedRoute';
import Employees from './pages/Employees/Employees';

const AllRoutes = () => {

  const location = useLocation();
  const isForbiddenPage = location.pathname === '/forbidden';

  return (
    <div className="h-100">
      <div className={"wrapper"}>
        {!isForbiddenPage && <Header/>}
        <div className={"main"}>
          <Routes>
            <Route path="/" element={
              <ProtectedRoute><Home/></ProtectedRoute>
            }/>
            <Route path="/home" element={
              <ProtectedRoute><Home/></ProtectedRoute>
            }/>
            <Route path="/login" element={
              <Login/>
            }/>
            {/* <Route path="/register" element={ */}
            {/*   <ProtectedRoute><Register/></ProtectedRoute> */}
            {/* }/> */}
            <Route path="/unauthorized" element={
              <ProtectedRoute><ForbiddenPage/></ProtectedRoute>
            }/>
            <Route path="/clients" element={
              <ProtectedRoute><Clients/></ProtectedRoute>
            }/>
            <Route path="/client-details" element={
              <ProtectedRoute><ClientDetails/></ProtectedRoute>
            }/>
            <Route path="/excursions" element={
              <ProtectedRoute><Excursions/></ProtectedRoute>
            }/>
            <Route path="/excursion-details/:id" element={
              <ProtectedRoute><ExcursionDetailsPage/></ProtectedRoute>
            }/>
            <Route path="/employees" element={
              <ProtectedRoute><Employees/></ProtectedRoute>
            }/>
            <Route path="/forbidden" element={
              <ProtectedRoute allowedRoles={['ROLE_USER', 'ROLE_ADMIN']} path="/forbidden">
                <ForbiddenPage />
              </ProtectedRoute>
            }/>
          </Routes>
        </div>
      </div>
      {!isForbiddenPage  && <Footer/>}
    </div>
  )
}

export default AllRoutes;